/** Choose tours by date range: the first and last start date of the bookings a range import brings
 *  (backend plan 2026-10-31 D2: from today on, in the company's time zone; no upper limit). Pure, so the
 *  rules are tested apart from the pickers. */
import type { Moment } from 'moment';
import moment from 'moment-timezone';

import type { BookingRange } from './api';

/** Today in the company's time zone (the backend refuses an earlier first date), as a calendar date in the
 *  pickers' own zone so they compare it by day. The browser's today when the zone is unknown. */
export function companyToday(timezone: string | null | undefined, now: Moment = moment()): Moment {
    const there = timezone && moment.tz.zone(timezone) ? moment.tz(now, timezone) : now;
    return moment(there.format('YYYY-MM-DD'), 'YYYY-MM-DD');
}

/** The range to import, or null until both dates are set, valid, from `today` on and in order. */
export function bookingRange(from: Moment | null, to: Moment | null, today: Moment): BookingRange | null {
    if (!from || !to || !from.isValid() || !to.isValid()) {
        return null;
    }
    if (from.isBefore(today, 'day') || to.isBefore(from, 'day')) {
        return null;
    }
    return { from, to };
}

/** "2 Nov 2026": a contract date (`YYYY-MM-DD`) or a picker's value, the calendar date itself (never converted). */
export const dayLabel = (day: string | Moment) => (typeof day === 'string' ? moment(day, 'YYYY-MM-DD') : day).format('D MMM YYYY');

/** "2 Nov 2026 to 20 Dec 2026". */
export const rangeLabel = (from: string | Moment, to: string | Moment) => `${dayLabel(from)} to ${dayLabel(to)}`;
